import React, { useEffect, useState } from "react";
import HeaderLogo from "../../../components/header/headerLogo";
import "../../../assets/scss/account/register.scss";
import verified from "../../../assets/images/verified.png";
import Repository from "../../../configs/axios/repository";
import "../../../assets/scss/invite.scss";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { handleCourseShow } from "../../../redux/layout";
import { handleLogout } from "../../../redux/authentication";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
const Invite = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({});
    const item = window.localStorage.getItem("userData");
    const queryParameters = new URLSearchParams(window.location.search);
    const course_id = queryParameters.get("course_id");
    const courseName = queryParameters.get("course_name");
    const emailNotDecoding = queryParameters.get("email");
    const email = decodeURIComponent(queryParameters.get("email"))?.replace(
        / /g,
        "+"
    );

    const accept = async () => {
        const result = await Repository.updateData(
            `api/course/addUserInInvitedUsers`,
            {
                course_id: Number(course_id),
                student_id: userData.id,
            }
        );

        if (result.data.statusCode == 302) {
            Swal.fire({
                icon: "warning",
                text: `You already have the course  ${courseName} `,
                confirmButtonColor: "#16285e",
            }).then((result) => {
                if (result.isConfirmed) {
                }
            });
        } else if (result.data.success) {
            Swal.fire({
                icon: "success",
                text: `You have successfully registered for course  ${courseName}`,
                confirmButtonColor: "#16285e",
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(handleCourseShow(true));
                    history.push({
                        pathname: "/courseDetails",
                        search: `course_id=${course_id}`,
                        state: { courseName },
                    });
                }
            });
        }
    };

    const findByEmailForInvate = async () => {
        const result = await Repository.findByEndPoint(
            `api/users/findByEmailForInvate/${email}`
        );
        const responce = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );

        if (result.data?.success && responce.data?.success) {
            if (result.data?.data == null) {
                dispatch(handleLogout());
            } else {
                if (
                    responce.data.data.user_role[0].role_id.name == "instructor"
                ) {
                    history.push({
                        pathname: "/courses",
                    });
                } else {
                    setLoading(true);
                    setUserData({
                        id: result.data.data.user_id,
                        userName: result.data.data.user_name,
                        is_invate: result.data.data.is_invate,
                        role: result.data.data.user_role[0].role_id.name,
                    });
                }
            }
        }
    };
    const findThisUser = async () => {
        const result = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );

        if (result.data?.success) {
            if (result.data?.data == null) {
                dispatch(handleLogout());
            } else {
                if (
                    result.data.data.user_role[0].role_id.name == "instructor"
                ) {
                    history.push({
                        pathname: "/courses",
                    });
                } else {
                    setLoading(true);
                    setUserData({
                        id: result.data.data.user_id,
                        userName: result.data.data.user_name,
                        is_invate: result.data.data.is_invate,
                        role: result.data.data.user_role[0].role_id.name,
                    });
                }
            }
        }
    };

    useEffect(() => {
        let localStorageData = JSON.parse(localStorage.getItem("userData"));
        if (localStorageData?.access_token != undefined) {
            if (emailNotDecoding != null) {
                findByEmailForInvate();
            } else {
                findThisUser();
            }
        } else {
            history.push({
                pathname: "/login",
                search:
                    emailNotDecoding != null
                        ? `course_id=${course_id}&email=${email}&course_name=${courseName}`
                        : `course_id=${course_id}&course_name=${courseName}`,
            });
        }
    }, []);

    return loading ? (
        <div className="verify ">
            <div className="headerParent mt-3">
                {item != undefined ? "" : <HeaderLogo />}
            </div>
            <div className="minHeight d-flex  justify-content-md-center">
                <div className="d-block  mb -1 verifyContentInvate">
                    <div>
                        <img
                            className="rounded mx-auto d-block"
                            src={verified}
                        />
                    </div>
                    <h3 className="text-center mt-4">
                        If you want to participate in this course, accept it,
                        otherwise cancel it.
                    </h3>

                    <div className="invateBtnDiv mt-4">
                        <button
                            className="acceptBtnInvate"
                            type="button"
                            onClick={() => {
                                accept();
                            }}
                        >
                            Accept
                        </button>
                        <button
                            className="cancelBtnInvate"
                            type="button"
                            onClick={() => {
                                if (userData.is_invate) {
                                    history.push({
                                        pathname: "/courses",
                                    });
                                } else {
                                    history.push({
                                        pathname: "/home",
                                    });
                                }
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default Invite;
